import Rs4ComponentBase from '@/shared/application/rs4-component-base';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Watch } from "vue-property-decorator";
import Guid from '@/shared/helpers/guid-helper';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
//import vuelidate from 'vuelidate';

//import { validationMixin } from 'vuelidate'
//import { required, maxLength, email } from 'vuelidate/lib/validators'

import EditarConvenio from './editar-convenio/editar-convenio.vue';

@Component({
     components: {
        EditarConvenio: require('./editar-convenio/editar-convenio.vue').default,
     }
})
export default class ConvenioListComponent extends Rs4ComponentBase {
    refs = this.$refs as any;
    loading = true;
    options = {};
    search = '';
    showModal = false;
    formTitle = '';
    errors: INameValueDto[] = [];
    //allRoles: IRoleDto[] = [];
    isEdit = false;
    selectAll = false;
    GuidEmpty = Guid.empty;

    format = "dd/MM/yyyy";
    dataInicio = new Date();
    dataInicioFormatted = '';

    id = Guid.empty;
    menu1 = false;
    menu2 = false;

    titulo = "Meu Teste";

    sexos = ['Masculino','Feminino'];
    items = [];
    content = '';

    get headers() {
        return [
            { text: 'Código', value: 'codigo' },
            { text: 'Nome', value: 'nome' },
            { text: 'Data de Início', value: 'dataInicio' },
            { text: 'Data de Término', value: 'dataTermino' },            
            { text: 'Ações', value: 'action', sortable: false, width: "150px", align: "center" }
        ];
    }

    createOrUpdateConvenioInput = {
        grantedRoleIds: [],
        convenio: {} as IConvenioDto
    } as ICreateOrUpdateConvenioInput;

    pagedListOfConvenioListDto: IPagedList<IPagedListInput> = {
        totalCount: 0,
        items: []
    };

    @Watch('options')
    onPaginationChanged() {
        this.getConvenios();
    }

    @Watch('search')
    onSearchChanged() {
        this.getConvenios();
    }

    mounted() {
        //this.getConvenios();
    }

    getConvenios() {
        this.loading = true;
        const { sortBy, sortDesc, page, itemsPerPage }: any = this.options;
        const userListInput: IPagedListInput = {
            filter: this.search,
            pageIndex: page - 1,
            pageSize: itemsPerPage
        };

        if (sortBy.length > 0 && sortBy[0]) {
            userListInput.sortBy = sortBy + ((sortDesc.length > 0 && sortDesc[0]) ? ' desc' : '');
        }

        const query = '?' + this.queryString.stringify(userListInput);
        this.rs4Service.get<IPagedList<IPagedListInput>>('/api/convenio' + query, false).then((response) => {
            this.pagedListOfConvenioListDto = response.content as IPagedList<IPagedListInput>;
            this.loading = false;
        });
    }

    parseDate (date: string) {
        debugger;
        if (!date) return null
  
        const [month, day, year] = date.split('/')
        return `${day.padStart(2, '0')}-${month.padStart(2, '0')}-${year}`
    }

    formatDate (date: string) {
        if (date)
            return moment(date).format("DD/MM/YYYY")
        else
            return ""
    }

    openModal(id: any){
        debugger;
        this.id = id;
        this.showModal = true;
    }

    handleClose(updated: boolean){
        debugger;
        if (updated)
        {
            this.getConvenios();    
        }
        this.showModal = false;
    }

    handleConfirmation(){
        this.getConvenios();
    }    
    editConvenio(id: string) {
        //this.id = id;
        this.openModal(id);
        this.formTitle = id ? "Editar Convenio" : "Novo Convênio";
        this.isEdit = id ? true : false;
        // this.errors = [];
        // this.rs4Service.get<IGetConvenioForCreateOrUpdateOutput>('/api/convenio/getConvenio?id=' + (id ? id : Guid.empty))
        //     .then((response) => {
        //         debugger;
        //         const result = response.content as IGetConvenioForCreateOrUpdateOutput;
        //         this.createOrUpdateConvenioInput = {
        //             convenio: result.convenio
        //         };
        //         if (!this.isEdit)
        //         {
        //             //this.createOrUpdateConvenioInput.convenio.DataInicio = new Date();
        //             //this.refs.form.reset();
        //         }
        //         //this.dataInicio = this.createOrUpdateConvenioInput.convenio.DataInicio?.toString();
        //         this.dialog = true;
        //         this.dialog = true;
        //     });
    }

    deleteConvenio(id: string) {
        this.swalConfirm(this.$t('AreYouSureToDelete').toString())
            .then((result) => {
                if (result.value) {
                    this.rs4Service.delete('/api/convenio/deleteconvenio?Id=' + id)                    
                        .then((response) => {
                            if (!response.isError) {
                                this.swalToast(2000, 'success', response.message);
                                this.getConvenios();
                            } else {
                                var errorText = "";
                                response.errors.forEach(error => {
                                    errorText += this.$t(error.name) + '<br>';
                                });

                                this.swalAlert('error', errorText);
                            }
                        });
                }
            });
    }

    save() {
        if (this.refs.form.validate()) {
            this.errors = [];
            this.rs4Service.post<void>('/api/convenio',
                this.createOrUpdateConvenioInput as ICreateOrUpdateConvenioInput
                )
                .then((response) => {
                    if (!response.isError) {
                        this.swalToast(2500, 'success', this.$t('Successful').toString());
                        this.isEdit = false;
                        this.getConvenios();
                        //this.dialog = false;
                    } else {
                        this.errors = response.errors;
                    }
                });
        }
    }

}
